import { Box, ClickAwayListener, Tooltip, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import UserIcon from '../../assets/Icons/UserIcon'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ChangeUserPassword from '../modal/ChangeUserPassword/ChangeUserPassword';
import { useEffect } from 'react';
import UserCollectionModal from '../Reports/UserCollection/UserCollectionModal';
import LogoutIcon from '@mui/icons-material/Logout';
import { useDispatch } from 'react-redux';
import { logOut } from '../../redux/Actions';
import AgentTicketModal from '../Reports/AgentTicket/AgentTicketModal';
import AgentTransactionsModal from '../Reports/AgentTxn/AgentTransactionsModal';

const UserMenu = () => {
    const anchorRef = useRef()
    const [openModal, setOpenModal] = useState({
        id: 0,
        open: false
    })
    useEffect(() => {
        const handleClickOutside = (e) => {
            if ((anchorRef.current && !anchorRef.current.contains(e.target)) && openModal.id === 1) {
                handleModal()
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const handleModal = (id = 0, open = false) => {
        setOpenModal((prev) => ({
            ...prev,
            id,
            open
        }))
    }

    return (
        <>
            <ClickAwayListener ref={anchorRef}
                onClickAway={() => {
                    if (openModal.id === 1) {
                        handleModal(0, false);
                    }
                }}
            >
                <Tooltip
                    open={openModal.id === 1 && openModal.open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    arrow
                    title={
                        <UserMenuList handleModal={handleModal} />
                    }
                    slotProps={{
                        popper: {
                            disablePortal: true,
                        },
                    }}
                    PopperProps={{
                        sx: {
                            '& .MuiTooltip-tooltip': {
                                backgroundColor: '#FFFFFF',
                                boxShadow: 'none',
                                zIndex: 1400,
                                borderRadius: '6px',
                                padding: '0 8px 0 0',
                            },
                            '& .MuiTooltip-arrow': {
                                color: '#FFFFFF',
                                width: '22px',
                                height: '13px',
                            },

                        },
                    }}
                >
                    <Box className='header_user_Section' onClick={() => {
                        handleModal(1, true)
                    }}>
                        <UserIcon />
                        <ArrowDropDownIcon sx={{ color: '#fff', padding: 0, }} />
                    </Box>
                </Tooltip>
            </ClickAwayListener>
            {openModal.open &&
                <>
                    {openModal.id === 5 &&
                        <ChangeUserPassword open={openModal.id === 5 && openModal.open}
                            titleText='Change Password'
                            onClose={handleModal}
                        />
                    }
                    {openModal.id === 2 &&
                        <UserCollectionModal open={openModal.id === 2} titleText='Userwise Collection' onClose={() => {
                            setOpenModal((prev) => ({
                                ...prev,
                                id: 0,
                                open: false,
                                data: {}
                            }))
                        }} />
                    }
                    {openModal.id === 3 &&
                        <AgentTicketModal open={openModal.id === 3} titleText='Agent Tickets' onClose={() => {
                            setOpenModal((prev) => ({
                                ...prev,
                                id: 0,
                                open: false,
                                data: {}
                            }))
                        }} />
                    }
                    {openModal.id === 4 &&
                        <AgentTransactionsModal open={openModal.id === 4} titleText='Agent Transactions' onClose={() => {
                            setOpenModal((prev) => ({
                                ...prev,
                                id: 0,
                                open: false,
                                data: {}
                            }))
                        }} />
                    }
                </>
            }
        </>

    )
}

export default UserMenu


const UserMenuList = (props) => {
    const { handleModal = () => { } } = props
    const dispatch = useDispatch()
    const optionList = [
        { id: 2, label: "User Collection" },
        { id: 3, label: "Agent Tickets" },
        { id: 4, label: "Agent Transactions" },
        { id: 5, label: "Change Password" },
        { id: 6, label: "Logout" },


    ]
    return (
        <Box className='userMenuList'>
            {optionList.map((obj) => (
                <Box sx={{ padding: '8px 16px', cursor: 'pointer' }}
                    onClick={() => {
                        if (obj.id === 6) {
                            dispatch(logOut())
                        } else {
                            handleModal(obj.id, true)
                        }
                    }}
                >
                    <Typography>{obj.id === 6 ?
                        <>
                            <LogoutIcon sx={{ fontSize: '16px', verticalAlign: 'middle', marginRight: '8px' }} />
                            <span style={{ verticalAlign: 'middle' }}>Logout</span>
                        </>
                        : obj.label}</Typography>
                </Box>
            ))}
        </Box>
    )
}